import React, { useEffect, useRef } from "react";
import { Popover } from "react-tiny-popover";
import { twMerge } from "tailwind-merge";
type Position = "bottom" | "left" | "right" | "top";

function UIPopover({
  children,
  trigger,
  positions,
  withChevron,
  containerClassName,
  popoverButtonClassName = "",
}: {
  children: (close: () => void, position?: string) => any;
  trigger: any;
  positions?: Position[];
  withChevron?: boolean;
  containerClassName?: string;
  popoverButtonClassName?: string;
}) {
  const clickMeButtonRef = useRef<any>();
  const [isPopoverOpen, setIsPopoverOpen] = React.useState(false);

  useEffect(() => {
    // on scroll, close the popover
    const handleScroll = (e) => {
      // check if scroll is outside the popover
      const element = document.getElementById("react-tiny-popover-container");
      if (element && !element.contains(e.target)) {
        setIsPopoverOpen(false);
      }
    };
    document.addEventListener("scroll", handleScroll, true);
    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Popover
      isOpen={isPopoverOpen}
      positions={positions || ["bottom", "left", "right", "top"]}
      clickOutsideCapture={true}
      onClickOutside={() => {
        setIsPopoverOpen(false);
      }}
      ref={clickMeButtonRef}
      content={({ position }) =>
        children(() => setIsPopoverOpen(!isPopoverOpen), position)
      }
      containerClassName={containerClassName}
    >
      <button
        className={twMerge(
          `flex flex-col ${isPopoverOpen
            ? "popover-open rounded-lg"
            : ""
          }`,
          popoverButtonClassName
        )}
        onClick={() => setIsPopoverOpen(!isPopoverOpen)}
      >
        {withChevron ? trigger(isPopoverOpen) : trigger}
      </button>
    </Popover>
  );
}

export default UIPopover;
